import {ErrorHandler, LOCALE_ID, NgModule} from '@angular/core';
import {AngularFireModule} from '@angular/fire/compat';
import {AngularFireAuthModule} from '@angular/fire/compat/auth';
import {AngularFireDatabaseModule} from '@angular/fire/compat/database';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {HttpClientModule} from '@angular/common/http';
import * as moment from 'moment';
import {BuchungModule} from "../buchung/buchung.module";
import { environment } from '../environments/environment';
import {SentryErrorHandler, SentryService} from "../utils/sentry.service";
import {AppMaterialModule} from "./app-material.module";
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { HomeComponent } from './home.component';
import { ImpressumComponent } from './impressum.component';
import { KitereisenComponent } from './kitereisen.component';
import { KontaktComponent } from './kontakt.component';
import { ReisenComponent } from './reisen.component';
import { ReiseComponent } from './reise.component';
import { DatenschutzComponent } from './datenschutz.component';
import {WintersportreisenComponent} from './wintersportreisen.component';
import {DownloadComponent} from './download.component';
import {firebase, firebaseui, FirebaseUIModule} from "firebaseui-angular";

const firebaseUiAuthConfig: firebaseui.auth.Config = {
  signInFlow: 'popup',
  signInOptions: [
    firebase.auth.GoogleAuthProvider.PROVIDER_ID,
    {
      provider: firebase.auth.FacebookAuthProvider.PROVIDER_ID,
      scopes: [
        'public_profile',
        'email',
      ],
    },
    {
      provider: firebase.auth.EmailAuthProvider.PROVIDER_ID,
      requireDisplayName: true // sinnvoll als Ersatz für Stammdaten
    },
  ],
  credentialHelper: firebaseui.auth.CredentialHelper.GOOGLE_YOLO
  /*
  callbacks: {
    signInSuccessWithAuthResult: (authResult, redirectUrl) => {
      // Do not redirect.
      return false;
    }
  },
  credentialHelper: firebaseui.auth.CredentialHelper.NONE,
  tosUrl: () => this.router.navigate(['/datenschutz']),
  privacyPolicyUrl: () => this.router.navigate(['/datenschutz']),
  */
};

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    ImpressumComponent,
    KitereisenComponent,
    KontaktComponent,
    ReisenComponent,
    WintersportreisenComponent,
    ReiseComponent,
    DatenschutzComponent,
    DownloadComponent
  ],
  imports: [
    BuchungModule,
    AppRoutingModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppMaterialModule,
    AngularFireModule.initializeApp(environment.firebase, environment.appName),
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    HttpClientModule,
    FirebaseUIModule.forRoot(firebaseUiAuthConfig),
  ],
  providers: [
    {provide: LOCALE_ID, useValue: 'de-DE'},
    {provide: ErrorHandler, useClass: SentryErrorHandler},
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(sentryService: SentryService) {
    sentryService.init(environment.sentry);
    moment.locale('de');
  }
}
